export const DISPLAY_TOGGLE_DEFAULTS = {
  showTitle: true,
  showSubtitle: false,
  showFormSwitchBar: true,
  showForgotPasswordLink: true,
} as const;
